import { Router, Switch, Route } from 'react-router-dom';
import vhCheck from 'vh-check';
import { history } from '$src/stores/history';
import { routes } from '$src/routes';
import RootStoreProvider from '$src/stores/RootStore';
import PrivateRoute from '$src/components/PrivateRoute';
import useStats from '$src/hooks/useStats';
import useBreakpoint from '$src/hooks/useBreakpoint';
import { Home, Locations, OnBoard, NotFound, Settings, Dashboard } from './pages';
import Onboarding from './pages/Onboarding';
import ReturnTo from './pages/ReturnTo';
import FreeTrial from './pages/FreeTrial';
import FreeTrialCanceled from './pages/FreeTrial/FreeTrialCanceled';
import UpsellPage from './pages/Upsell';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import './assets/less/index.less';
import ErrorBoundary from './components/ErrorBoundary';

vhCheck();

const AppMain = () => {
  useStats();
  useBreakpoint();

  return (
    <Router history={history}>
      <Switch>
        <Route exact path={routes.root} component={Home} />
        <Route exact path={routes.upsell} component={UpsellPage} />
        <Route exact path={routes.onboard} component={OnBoard} />
        <PrivateRoute exact path={routes.freeTrial} component={FreeTrial} />
        <PrivateRoute exact path={routes.freeTrialCanceled} component={FreeTrialCanceled} />
        <PrivateRoute exact path={routes.locations} component={Locations} />
        <PrivateRoute exact path={routes.dashboard} component={Dashboard} featureFlag="stark-feature-next-dashboard-smb-customers"/>
        <PrivateRoute path={routes.settings} component={Settings} />
        <Route path={routes.onboarding} component={Onboarding} />
        <PrivateRoute path={routes.returnTo} component={ReturnTo} />
        <Route component={NotFound} />
      </Switch>
    </Router>
  );
};

function withMobxStores(WrappedComponent) {
  return function App(props) {
    return (
      <RootStoreProvider>
        <ErrorBoundary>
          <WrappedComponent {...props} />
        </ErrorBoundary>
      </RootStoreProvider>
    );
  };
}

export default withMobxStores(AppMain);
